<template lang="pug">

ds-panel(space="3xl"): ds-panel-element(
  offset="full"
)
  div(slot="top-right")
    control-button.close-modal(
      styling="ghost",
      @click.prevent="$emit('close')"
      size="xs"
    ): icon(name="close", size="md")

  ds-panel: ds-panel-element(
    offset="vertical"
  ): ds-caption(size="2" variant="strong") {{ _("Оцініть якість обслуговування") }}
  
  template(
    v-for="(question, questionIndex) in questions"
  )
    div.questions-block-wrapper
      div.question-text-content
        span.question-text-content__title {{ question.text }}
        star-rating(
          @rating-selected="addAnswer(questionIndex)"
          :read-only="false"
          :increment=1
          :show-rating="false"
          active-color="#FFA500"
          inactive-color="#F0F2F5"
          v-model="questionsWithAnswers[questionIndex].mark"
          :padding=2
          :star-points="[14.015, 1.53027, 15.7194, 1.53027, 19.4953, 8.22934, 20.8274, 9.19716, 28.3654, 10.7181, 28.8921, 12.3391, 23.6877, 18.0003, 23.1789, 19.5663, 24.0617, 27.2053, 22.6828, 28.2072, 15.6905, 25.0069, 14.0439, 25.0069, 7.05155, 28.2072, 5.67264, 27.2053, 6.55551, 19.5663, 6.04669, 18.0003, 0.84231, 12.3391, 1.369, 10.7181, 8.90701, 9.19716, 10.2391, 8.22934, 14.015, 1.53027]"
        )
        //- div.answers-list
        //-   div.answer-item(
        //-     v-for="mark in [1,2,3,4,5]"
        //-   )
        //-     label.control-radio.--variant_flex
        //-       input.element(
        //-         type="radio"
        //-         :name='question.id'
        //-         :id="`${question.id}_${mark}`"
        //-         :value="`${question.id}_${mark}`"
        //-         @input="addAnswer(questionIndex, mark)"
        //-       )
        //-       label.control-radio__label(
        //-         :for="`${question.id}_${mark}`"
        //-       ) {{ mark }}
              //- span.control-radio__content.answer-content {{ mark }}
      
      div.answers-list(
        v-if='questionsWithAnswers[questionIndex].mark && questionsWithAnswers[questionIndex].mark < 4'
      )
        div.answer-item(
          v-for='reason in question.reasons'
        )
          label.control-checkbox.control-checkbox--styling_default.control-checkbox--type_checkbox
            input.control-checkbox__element(
              type="checkbox"
              :name='question.id'
              :id="`${question.id}_${reason.id}_reason`"
              :value="reason.id"
              @input="toggleReason(questionIndex, reason.id)"
            )
            label.control-checkbox__label(
              :for="`${question.id}_${reason.id}_reason`"
            )
            span.control-checkbox-text(
              :for="`${question.id}_${reason.id}_reason`"
            ) {{ reason.text }}
      
      form-line(
        v-if='questionsWithAnswers[questionIndex].mark && questionsWithAnswers[questionIndex].mark < 4'
      )
        form-cell(cols="12 "): d-textarea(
          :name="`${question.id}_comment`",
          v-model="questionsWithAnswers[questionIndex].comment",
          :placeholder="_('Уточнюючий коментар')",
        )
  div.btns-block-wrapper
    form-line
      form-cell(cols="narrow")
        control-button(
          tabindex="1"
          styling="primary",
          :class="{'disabled': answersCount!=questions.length}"
          @click.prevent="submitAnswers"
        ) {{ _('Підтвердити') }}
      form-cell(cols="narrow")
        control-button(
          tabindex="1"
          styling="secondary",
          @click.prevent="cancelReview"
        ) {{ _('Пізніше') }}

</template>

<script>
import { ratingReviews } from '@md/rating-reviews/api';
import StarRating from 'vue-star-rating'

export default {

  data() {
    return {
      questions: [],
      questionsWithAnswers: [],
      answersCount: 0
    };
  },

  components: {
    StarRating,
  },

  methods: {
    finish(payload) {
      
      this.$toast.success('Дякуємо за відгук!');
      this.$emit('close');
      
      // this.$emit('finish', payload);
    },

    async getQuestions() {
      console.log('getQuestions')
      const params = {}

      await ratingReviews.listOfQuestions.execute(
        params
      ).then(res => {
        console.log(res.results)
        if (res && res.results) {
          this.questions = res.results
          console.log(this.questions)
          this.questions.forEach(
            question => {
              console.log(question)
              this.questionsWithAnswers.push(
                {
                  question: question.id,
                  mark: null,
                  reasons: [],
                  comment: '',
                  addMark: false
                }
              )
            }
          )
        }
        console.log(this.questionsWithAnswers)
      })
    },
    setRating(rating) {
      console.log('setRating', rating)
    },
    addAnswer(questionIndex) {
      console.log('addAnswer')
      console.log('questionIndex', questionIndex)
      // console.log('mark', mark)
      console.log(this.questionsWithAnswers[questionIndex].mark)
      if (!this.questionsWithAnswers[questionIndex].addMark) {
        this.answersCount += 1
        this.questionsWithAnswers[questionIndex].addMark = true
      }
      // this.questionsWithAnswers[questionIndex].mark = mark
      this.questionsWithAnswers[questionIndex].reasons = []
      this.questionsWithAnswers[questionIndex].comment = ''
      console.log(this.questionsWithAnswers)
      console.log(this.answersCount)
    },
    toggleReason(questionIndex, reasonId) {
      console.log('toggleReason')
      console.log('questionIndex', questionIndex)
      console.log('reasonId', reasonId)
      const indexOfReason = this.questionsWithAnswers[questionIndex].reasons.indexOf(reasonId)
      if (indexOfReason !== -1) {
        console.log('убираем причину')
        this.questionsWithAnswers[questionIndex].reasons.splice(indexOfReason, 1)
      } else {
        console.log('добавляем причину')
        this.questionsWithAnswers[questionIndex].reasons.push(reasonId)
      }
      console.log(this.questionsWithAnswers)
    },
    async submitAnswers() {
      console.log('submitAnswers')
      // this.isLoad = true

      const params = {
        answers: this.questionsWithAnswers,
      }

      await ratingReviews.finish.execute(
        {},
        params
      ).then(res => {
        this.finish()
      })
      // this.isLoad = false
    },
    async cancelReview() {
      console.log('cancelReview')
      await ratingReviews.cancel.execute(
        {},
        {}
      ).then(res => {
        this.$emit('close');
      })
    },
  },

  async mounted() {
    console.log('rating reviews modal')
    await this.getQuestions()
  },
};

</script>
